import { css } from "lit";

export const styles = css`
  :host {
    display: block;
  }

  .input-wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
  }

  .container {
    display: flex;
    align-items: flex-end;
    gap: var(--sds-size-space-300);
    min-height: 40px;
  }

  /* Single line state: vertical centering */
  .container.single-line {
    align-items: center;
  }

  .pill {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: flex-end;
    gap: var(--sds-size-space-200);
    background: var(--sds-color-background-default-tertiary, #444);
    border-radius: 20px;
    padding: 0 var(--sds-size-space-300);
    min-height: 40px;
  }

  .container.single-line .pill {
    align-items: center;
  }

  .message-input {
    flex: 1;
    min-width: 0;
    border: none;
    background: transparent;
    color: var(--sds-color-text-default-default, #f3f3f3);
    font-size: var(--sds-typography-body-size-medium);
    font-family: var(--sds-typography-family-body);
    line-height: 1.4;
    resize: none;
    outline: none;
    padding: var(--sds-size-space-300) 0;
    margin: 0;
    min-height: 22px;
    max-height: 120px;
    overflow-y: auto;
  }

  .message-input::placeholder {
    color: var(--sds-color-text-default-tertiary, rgb(255 255 255 / 0.7));
  }

  .message-input:disabled {
    opacity: 0.5;
  }

  .attach-button {
    width: 30px;
    height: 30px;
    flex-shrink: 0;
    align-self: flex-end;
    margin-bottom: 5px;
    border: none;
    background: transparent;
    color: var(--sds-color-icon-default-default);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: var(--sds-size-radius-full);
    transition:
      color 0.2s ease,
      background 0.2s ease;
  }

  .container.single-line .attach-button {
    align-self: center;
    margin-bottom: 0;
  }

  .attach-button:not(:disabled):hover {
    background: var(--sds-color-background-default-secondary);
  }

  .attach-button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .emoji-button {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    align-self: flex-end;
    margin-bottom: 6px;
    border: none;
    background: transparent;
    color: var(--sds-color-icon-default-secondary, rgb(255 255 255 / 0.7));
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: var(--sds-size-radius-full);
    transition:
      color 0.2s ease,
      background 0.2s ease;
  }

  .container.single-line .emoji-button {
    align-self: center;
    margin-bottom: 0;
  }

  .emoji-button:not(:disabled):hover {
    color: var(--sds-color-icon-default-default, #fff);
  }

  .emoji-button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .send-button {
    width: 38px;
    height: 38px;
    flex-shrink: 0;
    align-self: flex-end;
    margin-bottom: 1px;
    border: none;
    background: var(--sds-color-white-1000);
    color: var(--sds-color-brand-900);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: var(--sds-size-radius-full);
    transition:
      opacity 0.2s ease,
      transform 0.1s ease;
  }

  .container.single-line .send-button {
    align-self: center;
    margin-bottom: 0;
  }

  .send-button:not(:disabled):hover {
    transform: scale(1.05);
  }

  .send-button:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

  /* Attachment options popup row */
  .attachment-options {
    display: flex;
    gap: var(--sds-size-space-300);
    align-items: flex-start;
    padding: var(--sds-size-space-300) 0 0;
  }

  .attachment-option {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--sds-size-space-150);
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    color: var(--sds-color-text-default-default, #fff);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    width: 87px;
  }

  .attachment-option-circle {
    width: 60px;
    height: 60px;
    border-radius: var(--sds-size-radius-full);
    background: var(--sds-color-background-default-tertiary, #444);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--sds-color-icon-default-default, #fff);
    transition:
      transform 0.15s ease,
      background 0.2s ease;
  }

  .attachment-option:hover .attachment-option-circle,
  .attachment-option:focus-visible .attachment-option-circle {
    background: var(--sds-color-background-default-secondary);
    transform: scale(1.04);
  }

  .attachment-option-label {
    line-height: 1.2;
    text-align: center;
  }

  /* Attachment chips */
  .attachment-chips {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: var(--sds-size-space-200);
  }

  .chip {
    display: inline-flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    background: var(--sds-color-background-default-secondary);
    border-radius: var(--sds-size-radius-200);
    padding: var(--sds-size-space-150) var(--sds-size-space-300);
    font-size: var(--sds-typography-body-size-small);
    font-family: var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
    max-width: 240px;
  }

  .chip.uploading {
    opacity: 0.75;
  }

  .chip.error {
    background: var(--sds-color-background-danger-secondary, #fde8e8);
    color: var(--sds-color-text-danger-default, #c53030);
  }

  .chip-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 140px;
  }

  .chip-meta {
    color: var(--sds-color-text-default-tertiary);
    font-variant-numeric: tabular-nums;
  }

  .chip.error .chip-meta {
    color: inherit;
  }

  .chip-remove {
    border: none;
    background: transparent;
    padding: 0;
    color: inherit;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .chip-remove:hover {
    color: var(--sds-color-text-default-default);
  }

  /* Mobile adjustments */
  @media (max-width: 768px) {
    .container {
      gap: var(--sds-size-space-200);
    }

    .message-input {
      font-size: 16px; /* Prevents iOS Safari auto-zoom on focus */
    }
  }

  /* Landscape mobile: more compact */
  @media (max-height: 500px) and (orientation: landscape) {
    .container,
    .pill {
      min-height: 36px;
    }

    .message-input {
      font-size: var(--sds-typography-body-size-medium);
      min-height: 20px;
      max-height: 80px;
      padding: var(--sds-size-space-200) 0;
    }

    .send-button {
      width: 34px;
      height: 34px;
    }

    .attach-button {
      width: 28px;
      height: 28px;
    }
  }

  .char-counter {
    font-size: var(--sds-typography-body-size-small);
    font-family: var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
    text-align: right;
  }

  .char-counter.over-limit {
    color: var(--sds-color-text-danger-default, #e53e3e);
  }

  .notify-toggle {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    cursor: pointer;
    user-select: none;
  }

  .notify-toggle input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin: 0;
    cursor: pointer;
    accent-color: var(--sds-color-icon-default-default);
    flex-shrink: 0;
  }

  .notify-label {
    font-size: var(--sds-typography-body-size-small);
    font-family: var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    line-height: 1.4;
  }

  /* Pre-send media preview overlay (image/video) — full-screen experience.
     Rendered via the Popover API (top layer) so it escapes ancestor transforms
     (e.g. swipeable tab containers) and always covers the full viewport. */
  .media-preview-overlay {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100dvh;
    max-width: none;
    max-height: none;
    margin: 0;
    padding: 0;
    border: none;
    overflow: hidden;
    background: var(--sds-color-background-default-default);
    flex-direction: column;
  }

  .media-preview-overlay:popover-open {
    display: flex;
  }

  .media-preview-header {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-300);
    padding: var(--sds-size-space-200) var(--sds-size-space-400);
    min-height: 52px;
    flex-shrink: 0;
  }

  .media-preview-close,
  .media-preview-toggle {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: var(--sds-size-radius-full);
    background: var(--sds-color-background-default-tertiary, #444);
    color: var(--sds-color-icon-default-default);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .media-preview-toggle {
    background: transparent;
  }

  .media-preview-title {
    flex: 1;
    min-width: 0;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-bold, 700);
    font-size: var(--sds-typography-body-size-small);
    color: var(--sds-color-text-default-default);
  }

  .media-preview-header-spacer {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
  }

  .media-preview-body {
    flex: 1;
    min-height: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .media-preview-media {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .media-preview-play-overlay {
    position: absolute;
    inset: 0;
    margin: auto;
    width: 80px;
    height: 80px;
    border: none;
    background: transparent;
    color: var(--sds-color-icon-default-default);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .media-preview-input {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-150);
    padding: var(--sds-size-space-400);
    border-top: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
  }

  .media-preview-progress {
    font-size: var(--sds-typography-body-size-small);
    font-family: var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
    font-variant-numeric: tabular-nums;
  }

  .media-preview-error {
    font-size: var(--sds-typography-body-size-small);
    font-family: var(--sds-typography-family-body);
    color: var(--sds-color-text-danger-default, #e53e3e);
  }
`;
